import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import {
  BaseComponent,
  NetworkConnectionService,
  PITEventService,
  SystemEnvironment,
  UtilsString,
} from '@pit/core';
import { IDtoDepot, IDtoUser, IDtoUserRole } from '@pit/frontend-model';
import {
  EventUI,
  IPinItTrackFrontendApplicationService,
  PinItTrackFrontendServicesAccessor,
  VersionService,
  VersionInfo
} from '@pit/frontend-shared';
import { Observable } from 'rxjs';

@Component({
  selector: 'pin-it-track-web-app-topbar',
  templateUrl: './pin.it.track.web.app.topbar.component.html',
  styleUrls: ['./pin.it.track.web.app.topbar.component.scss'],
  animations: [
    trigger('topbarActionPanelAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scaleY(0.8)' }),
        animate('.12s cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 1, transform: '*' })),
      ]),
      transition(':leave', [animate('.1s linear', style({ opacity: 0 }))]),
    ]),
  ],
})
export class PinItTrackWebAppTopbarComponent extends BaseComponent {
  private isConectedToNetwork: boolean = false;
  private isConnectedToServer: boolean = false;
  private _selectedDepot: IDtoDepot = null;

  constructor(
    private readonly servicesAccessor: PinItTrackFrontendServicesAccessor,
    private networkConnectionService: NetworkConnectionService,
    private versionService: VersionService
  ) {
    super(servicesAccessor.coreServicesAccessor.applicationService);

    this.applicationServiceExt = servicesAccessor.coreServicesAccessor.applicationService;
    this.versionInfo = this.versionService.getVersionInfo();
  }

  public currentUser: IDtoUser = this.servicesAccessor.currentUser;

  // The signed-in user travels through the session storage as JSON, which drops every
  // computed member of the DTO. fullName and roleDescription are gone by the time they
  // reach this component, so both are derived from the plain fields that do survive.
  public get userDisplayName(): string {
    const parts: string[] = [this.currentUser?.firstName, this.currentUser?.lastName]
      .filter((x) => (UtilsString.stringIsNullOrEmpty(x) === false));

    return (parts.length > 0) ? parts.join(' ') : (this.currentUser?.userName || 'Unknown User');
  }

  public get userRoleDescription(): string {
    const roles: IDtoUserRole[] = (this.currentUser?.userRoles || []);
    if (roles.length === 0) {
      return '';
    }

    // Highest level wins, so the list is sorted before the last entry is taken.
    const sorted: IDtoUserRole[] = [...roles].sort((a, b) => (a.level - b.level));

    return (sorted[sorted.length - 1].description || '');
  }

  public isLoading$: Observable<boolean> =
    this.servicesAccessor.coreServicesAccessor.applicationService.isLoading$;

  public isLiveSystem: boolean =
    this.configService.configSystem.environment === SystemEnvironment.Production;

  public get selectedDepot(): IDtoDepot {
    return this._selectedDepot;
  }

  public set selectedDepot(value: IDtoDepot) {
    if (value !== this.selectedDepot) {
      this._selectedDepot = value;

      this.servicesAccessor.selectedDepot = this.selectedDepot;
    }
  }

  public readonly applicationServiceExt: IPinItTrackFrontendApplicationService = null;

  public versionInfo: VersionInfo;

  public networkItemClass: string = 'fa fa-2x fa-dot-circle network-disabled';

  public async editUserAsync(): Promise<void> {
    /*this.eventService.sendEvent('dialog', {
            type: 'user',
            data: this.entityStoreFacadesAccessor.user
        });*/
  }

  public async logoutAsync(): Promise<void> {
    this.servicesAccessor.eventService.sendEvent('auth', {
      type: 'logout',
    });
  }

  public async reloadDataAsync(): Promise<void> {
    /*try {
            this.eventService.useMethod('busy.on');
            await this.entityStoreFacadesAccessor.dtoMailingStoreFacade.loadMailingsForRecipientAsync(this.entityStoreFacadesAccessor.recipient.id);
        } catch (error) {
            this.loggingService.error(error);
        } finally {
            this.eventService.useMethod('busy.off');
        }*/
  }

  protected override async doOnAfterViewInitAsync(): Promise<void> {
    await super.doOnAfterViewInitAsync();

    // Safely access the first depot with null checks
    if (this.currentUser?.depots && this.currentUser.depots.length > 0) {
      this.selectedDepot = this.currentUser.depots[0];
    }

    this.servicesAccessor.eventService.subscribeForEvent(
      'network',
      this.handleNetworkEvent.bind(this)
    );

    this.networkConnectionService.refreshState();
  }

  private handleNetworkEvent(data: any): void {
    let networkItemClass: string = 'fa fa-2x fa-dot-circle network-disabled';
    if (data.type === 'signalr') {
      this.isConnectedToServer = data.state === true;
    } else {
      this.isConectedToNetwork = data.state === true;
    }
    if (this.isConnectedToServer === true) {
      networkItemClass = 'fa fa-2x fa-database network-enabled';
    } else if (this.isConectedToNetwork) {
      networkItemClass = 'fa fa-2x fa-network-wired network-enabled';
    }

    this.networkItemClass = networkItemClass;
  }
}
